import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Spinner,
  Button,
  Icon,
} from "@chakra-ui/react";
import { CheckCircleIcon, WarningIcon } from "@chakra-ui/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const EmailVerificationPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get("token");

      if (!token) {
        setStatus("error");
        setMessage("Verification token is missing");
        return;
      }

      try {
        const config = {
          headers: {
            "Content-type": "application/json",
          },
        };

        const { data } = await axios.post(
          "/api/user/verify-email",
          { token },
          config
        );

        setStatus("success");
        setMessage(data.message);

        // Store token if provided
        if (data.token) {
          localStorage.setItem("authToken", data.token);
        }
      } catch (error) {
        setStatus("error");
        setMessage(
          error.response?.data?.message ||
            "Email verification failed. Please try again."
        );
      }
    };

    verifyEmail();
  }, [searchParams]);

  const handleNavigateToLogin = () => {
    navigate("/");
  };

  return (
    <Container maxW="xl" centerContent>
      <Box
        d="flex"
        justifyContent="center"
        p={3}
        bg="white"
        w="100%"
        m="40px 0 15px 0"
        borderRadius="lg"
        borderWidth="1px"
      >
        <Heading
          as="h1"
          size="xl"
          textAlign="center"
          fontFamily="Work Sans"
          color="black"
        >
          Email Verification
        </Heading>
      </Box>

      <Box
        bg="white"
        w="100%"
        p={8}
        borderRadius="lg"
        borderWidth="1px"
        textAlign="center"
      >
        <VStack spacing={6}>
          {status === "verifying" && (
            <>
              <Spinner size="xl" color="blue.500" thickness="4px" />
              <Text fontSize="lg" color="gray.600">
                Verifying your email address...
              </Text>
            </>
          )}

          {status === "success" && (
            <>
              <Icon as={CheckCircleIcon} boxSize={20} color="green.500" />
              <Heading size="lg" color="green.600">
                Email Verified!
              </Heading>
              <Text fontSize="md" color="gray.600">
                {message}
              </Text>
              <VStack spacing={3} width="100%">
                <Button
                  variant="outline"
                  colorScheme="blue"
                  width="100%"
                  onClick={handleNavigateToLogin}
                >
                  Go to Homepage
                </Button>
              </VStack>
            </>
          )}

          {status === "error" && (
            <>
              <Icon as={WarningIcon} boxSize={20} color="red.500" />
              <Heading size="lg" color="red.600">
                Verification Failed
              </Heading>
              <Text fontSize="md" color="gray.600">
                {message}
              </Text>
              <Text fontSize="sm" color="gray.500" mt={2}>
                The verification link may have expired or is invalid. Please try
                signing up again or contact support.
              </Text>
              <Button
                colorScheme="blue"
                width="100%"
                onClick={handleNavigateToLogin}
              >
                Go to Homepage
              </Button>
            </>
          )}
        </VStack>
      </Box>
    </Container>
  );
};

export default EmailVerificationPage;
